import { getToday } from '@shared/services/dateService';
import { useSelectedDateStore } from '../../../CalendarStore';
import { useEffect } from 'react';
import { useShallow } from 'zustand/shallow';

export const useSetSelectedDate = () => {
  const today = getToday();

  const [selectedDate, setSelectedDate] = useSelectedDateStore(
    useShallow(state => [state.selectedDate, state.setSelectedDate])
  );

  useEffect(() => {
    if (selectedDate) {
      return;
    }
    setSelectedDate(today);
  }, [selectedDate, setSelectedDate, today]);

  return {
    selectedDate,
    setSelectedDate
  };
};
